export default "__VITE_ASSET__CF6YvVJA__"